import { inject as n, computed as a, toValue as l } from "vue";
const u = [260, 640, 750, 828, 1080, 1200, 1920, 2048, 3840], m = {
  format: "auto",
  quality: 75
}, E = /* @__PURE__ */ Symbol("locale"), p = /* @__PURE__ */ Symbol("illustrationOptimizer"), R = /* @__PURE__ */ Symbol("translateFunction"), I = /* @__PURE__ */ Symbol("RouterLinkComponent"), r = "Revolve was not initialized, please import and use `createRevolvePlugin`.", L = () => {
  const o = n(E);
  if (o === void 0)
    throw new Error(r);
  return o;
}, T = (o) => {
  const e = n(p);
  if (e === void 0)
    throw new Error(r);
  return a(() => {
    const i = u.map((t) => ({
      optimizedPath: e(l(o), t, m),
      width: t
    })), s = i.map(({ optimizedPath: t, width: c }) => `${t} ${c}w`).join(",");
    return {
      src: i[0].optimizedPath,
      srcset: s
    };
  });
}, N = () => {
  const o = n(I);
  if (o === void 0)
    throw new Error(r);
  return o;
}, S = () => {
  const o = n(R);
  if (o === void 0)
    throw new Error(r);
  return o;
};
export {
  p as ILLUSTRATION_OPTIMIZER,
  E as LOCALE,
  I as ROUTER_LINK_COMPONENT,
  R as TRANSLATE_FUNCTION,
  S as useI18n,
  T as useIllustrationOptimizer,
  L as useLocale,
  N as useRouterLinkComponent
};
